var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthorizationLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1008_1111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.1992,
    y: 20.3,
    width: 116,
    height: 116,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6992,
    y: 20.8,
    width: 115,
    height: 115,
    rx: 23.5,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.794 67.7798C103.812 67.0302 103.552 66.3003 103.064 65.7307C102.576 65.1614 101.895 64.792 101.152 64.6943H96.2809C96.2809 64.6943 94.211 60.9903 93.1954 58.7412C90.9462 53.1184 83.5909 52.3769 71.4563 52.3523C59.3216 52.3277 51.9627 53.1149 49.7171 58.7412C48.7015 60.9903 46.6316 64.6943 46.6316 64.6943H41.7609C41.0168 64.7906 40.3347 65.1593 39.8466 65.7293C39.3585 66.2989 39.0989 67.0299 39.1182 67.7798C39.1182 71.4452 41.543 71.2941 41.543 71.2941H43.7464C42.0104 76.6463 40.3974 79.4928 40.3974 84.736V98.793C40.3974 101.604 43.019 102.806 45.8163 102.806C48.6137 102.806 51.2494 101.59 51.2494 98.793V96.5896H91.6632V98.793C91.6632 101.604 94.2988 102.806 97.0962 102.806C99.8935 102.806 102.508 101.604 102.508 98.793V84.736C102.508 79.4928 100.895 76.6533 99.159 71.2941H101.362C101.362 71.2941 103.794 71.4452 103.794 67.7798ZM56.215 89.1851H51.0244C50.4936 89.1844 49.9661 89.1014 49.4606 88.9391C48.1818 88.5251 47.1199 87.6205 46.5083 86.4236C45.8967 85.2266 45.7855 83.836 46.1994 82.5572C46.6132 81.2784 47.5181 80.2164 48.7149 79.6049C49.9117 78.9934 51.3025 78.882 52.5813 79.296L52.6656 79.3206C54.3173 79.8548 60.8011 83.8013 60.8011 86.6337C60.8011 89.4662 58.0108 89.1851 56.215 89.1851ZM51.3196 70.4155C50.1213 70.4155 49.5168 69.3085 49.9561 67.9977L53.7093 59.7111C53.9479 59.1221 54.3499 58.6137 54.8679 58.2456C55.386 57.8776 55.9985 57.6655 56.6332 57.6342H86.2793C86.914 57.6655 87.5265 57.8776 88.0445 58.2456C88.5625 58.6137 88.9646 59.1221 89.2032 59.7111L92.9564 67.9977C93.3957 69.3085 92.7912 70.4155 91.5929 70.4155H51.3196ZM93.4519 88.9391C92.9466 89.1014 92.4191 89.1844 91.8881 89.1851H86.694C84.8982 89.1851 82.1079 89.4662 82.1079 86.6337C82.1079 83.8013 88.5917 79.8548 90.2434 79.3206L90.3277 79.296C91.6066 78.882 92.9972 78.9934 94.1941 79.6049C95.3911 80.2164 96.2956 81.2784 96.7096 82.5572C97.1236 83.836 97.0122 85.2266 96.4007 86.4236C95.7892 87.6205 94.7272 88.5251 93.4484 88.9391H93.4519Z",
    fill: "#2B3842"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1008_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.857 97.4979C103.488 97.4979 104.811 98.8204 104.811 100.451V102.665C104.811 104.295 103.488 105.617 101.857 105.617H73.8105C72.18 105.617 70.8574 104.295 70.8574 102.665V100.451C70.8574 98.8204 72.18 97.4979 73.8105 97.4979H101.857ZM102.757 49.0809C103.91 47.9272 105.78 47.9266 106.934 49.0799L124.938 67.0858C126.091 68.2387 126.091 70.1076 124.938 71.2606L122.974 73.2254C122.183 74.0154 121.014 74.2911 119.954 73.9383L118.943 73.6024L114.238 78.3074L126.765 90.8338C127.918 91.9868 127.918 93.8566 126.765 95.0096L125.199 96.574C124.046 97.727 122.177 97.727 121.024 96.574L108.498 84.0486L103.923 88.6238L104.248 89.9256C104.5 90.932 104.205 91.997 103.471 92.7303L101.45 94.7488C100.297 95.9009 98.4291 95.9012 97.2764 94.7488L79.2695 76.742C78.1171 75.5893 78.1173 73.7202 79.2695 72.5672L81.2881 70.5477C82.0213 69.814 83.0855 69.5189 84.0918 69.7703L85.3945 70.0955L100.416 55.075L100.08 54.0672V54.0662C99.7272 53.006 100.003 51.8371 100.793 51.0467L102.757 49.0809Z",
    fill: "url(#paint0_linear_1008_1111)",
    stroke: "white",
    strokeWidth: 2.95238
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1008_1111",
    x: -0.000778198,
    y: -0.00000953674,
    width: 162.4,
    height: 162.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1008_1111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1008_1111",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_1111",
    x1: 126.682,
    y1: 74.1867,
    x2: 75.1009,
    y2: 69.5303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A854FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580392,
    stopColor: "#6058FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1008_1111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(67.1543 47.3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizationLogo);
export default __webpack_public_path__ + "static/media/authorizationLogo.344d35a0f9e1e14a9575a5871b1d4441.svg";
export { ForwardRef as ReactComponent };